<template>
  <div class="grid grid-cols-2 gap-6">
    <div class="text-sm/6 font-medium">
      {{ t('guests.adults') }}
    </div>
    <TCounterInput
      :model-value="adults"
      :min="minAdults"
      :max="maxGuests - children"
      data-testid-prefix="booking-adults"
      class="justify-self-end"
      @update:model-value="updateAdults"
    />

    <div class="text-sm/6 font-medium">
      {{ t('guests.children') }}
    </div>
    <TCounterInput
      :model-value="children"
      :max="maxGuests - adults"
      data-testid-prefix="booking-children"
      class="justify-self-end"
      @update:model-value="updateChildren"
    />
  </div>
</template>

<script setup lang="ts">
const props = withDefaults(defineProps<{
  adults: number
  children: number
  minAdults?: number
  maxGuests?: number
}>(), {
  minAdults: 1,
  maxGuests: 99,
})

const emit = defineEmits<{
  'update:adults': [adults: number]
  'update:children': [children: number]
  'update:guests': [{ adults: number, children: number }]
}>()

const { t } = useI18n()

function updateAdults(adults: number) {
  emit('update:adults', adults)
  emit('update:guests', { adults, children: props.children })
}

function updateChildren(children: number) {
  emit('update:children', children)
  emit('update:guests', { adults: props.adults, children })
}
</script>

<i18n src="~~/i18n/locales/common/search/form/guests.json" lang="json" />
